const UK_PAYER_BASE_OPTIONS = [
    { label: "B2B - Businesses only", value: "b2b" },
    { label: "B2C - Consumers only", value: "b2c" },
    { label: "Mixed B2B and B2C", value: "mixed" },
];

export default UK_PAYER_BASE_OPTIONS;
